import { render, staticRenderFns } from "./Problem.vue?vue&type=template&id=6401bb80&scoped=true&"
import script from "./Problem.vue?vue&type=script&lang=js&"
export * from "./Problem.vue?vue&type=script&lang=js&"
import style0 from "./Problem.vue?vue&type=style&index=0&id=6401bb80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401bb80",
  null
  
)

export default component.exports